<div class="financial-health-protection-card mfp-white-box">
  <div class="card__row">
    <img
      *ngIf="insurance"
      mfpLazyImage
      lazySrc="assets/icons/protection-card-{{insurance}}.svg"
      [ngClass]="insurance !== 'DEATH' ? 'card__icon' : 'card__icon-large' "
    />
    <h2 class="card__title">{{ title }}</h2>
  </div>
  <h2 class="card__value">{{ value + '%' }}</h2>
  <p class="card__description">{{ description }}</p>
</div>
